import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";
import { styled } from "../stitches.config";
import { withRouter } from "react-router-class-tools";

//components
import Adslot from './Adslot'
import Error from "./Error";
import Loader from "./Loader";
import { TagsWrapper } from "./Article/Components/Tags";
import Link from "./Link";
// import PhotoOnLeft from "./common/PhotoOnLeft";
// import PhotoOnTop from './common/PhotoOnTop'
import { ShowMore } from './PostsList'
import KulkiSvg from "./common/KulkiSvg"
import BlockList from "./common/BlockList";
import Breadcrumbs from "../redesign/components/Breadcrumbs";

import PhotoOnLeft from "../redesign/components/PhotoOnLeft";
import PhotoOnTop from '../redesign/components/PhotoOnTop'

import Heading from '../redesign/atoms/Heading';

import PaginatorPosts from '../redesign/PaginatorPosts';

import { IS_FEATURE_PAGINATOR_LIST, IS_FEATURE_adunityPartner } from "./common/constants/constants";
import Footer from "../redesign/components/Footer"

import PageCover from "../redesign/components/PageCover";

@inject("TopicStore", "UIStore")
@observer
class TopicPage extends Component {

    @observable posts = this.props.TopicStore.fetchedTopic.topic.last_posts;
    @observable nextPage = `${window.API_HOST}/pwa-topic/${this.props.TopicStore.currentSlug}?to_date=${encodeURIComponent(this.props.TopicStore.fetchedTopic.LAST_POSTS_LAST_DATE)}`;
    @observable pending = false;
    @observable hideButton = false;

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.slug !== this.props.match.params.slug) {
            this.props.TopicStore.updateSlug(nextProps.match.params.slug);
        }
    }

    componentWillMount(nextProps) {
        this.props.TopicStore.updateSlug(this.props.match.params.slug);
    }

    fetchPosts = ({
        url
    } = {}) => {
        this.pending = true;
        fetch(url)
            .then(res => {
                if (!res.ok) return Promise.reject();
                return res.json();
            })
            .then(res => {
                this.pending = false;
                if (typeof res.LAST_POSTS_LAST_DATE === "undefined") {
                    this.hideButton = true;
                } else {
                    this.nextPage = `${window.API_HOST}/pwa-topic/${this.props.TopicStore.currentSlug}?to_date=${encodeURIComponent(res.LAST_POSTS_LAST_DATE)}`;
                }
                this.posts.length !== 0 ? this.posts = [...this.posts, ...res.topic.last_posts] : this.posts = res.topic.last_posts
                // console.log({ response, nextPage: this.nextPage })
            })
            .catch(() => {
                this.pending = false;
                // console.log("no match found")
            });
    };

    render() {
        const { TopicStore, UIStore } = this.props;

        if (TopicStore.status === "loading")
            return <Loader />;
        if (TopicStore.status === "error")
            return <Error error={TopicStore.message} />;

        // category is available
        const { changeUIType, trackPageView } = UIStore;
        const { topic } = TopicStore.fetchedTopic;
        const categoryBlocks = topic.wizard;

        let adPrefix = "KAT";
        const isMaterialPartnera = UIStore.isMaterialPartnera;
        const adSuffix = ((IS_FEATURE_adunityPartner && isMaterialPartnera) ? '_partner' : '');

        this.props.UIStore.setCurrentAction(['category', 'category-' + 'sg']);

        document.title = topic.seo_title;
        trackPageView({ title: topic.seo_title });
        changeUIType(topic);
        return (
            <>
                <Fragment key="home-page-container">
                    <Adslot name="belka_sticky" lazy={false} />
                    <Adslot name="nat_expander" lazy={false} />
                    <Adslot name={adPrefix + "_Billboard_1" + adSuffix} only="desktop" />
                    <div className="hp">
                        {/* <Adslot name={adPrefix + "_premium"} lazy={false} /> */}
                        <PageCover
                            beforeContent={
                                <Breadcrumbs
                                    category={{ name: topic.name, link: topic.path }}
                                    allWhite
                                />
                            }
                            title={topic.name}
                            description={topic.description}
                            isDescriptionWyswig={false}
                            image={topic?.lead_picture?.img}
                            media={topic?.lead_picture?.media}
                            extraMargin={categoryBlocks && categoryBlocks.length && categoryBlocks[0].type == 'b-one-super'}
                            hideMobileImage={true}
                        />
                        <BlockList settings={categoryBlocks} />
                        <div className="container">
                            {topic.last_posts?.length > 0 &&
                                <PaginatorPosts
                                    label="Najnowsze wiadomości"
                                    id={topic.OID}
                                    dataType="topic"
                                    type="list"
                                    pageSize={10}
                                    paginationType="PAGINATOR"
                                    preloadedApiResponse={topic?.api_response}
                                />
                            }
                            {/* {topic.last_blogs?.length > 0 &&
                                <div className="row">
                                    <Heading title="Blogi" />
                                    {topic.last_blogs.map(post => {
                                        return <div className="col-xs-12 col-sm-6 col-md-3">
                                            {UIStore.isDesktop
                                                ? <PhotoOnTop article={post} />
                                                : <PhotoOnLeft article={post} />}
                                        </div>
                                    })}
                                </div>} */}
                            {topic.extra_topics?.length > 0 &&
                                <TagsWrapper>
                                    <span> Powiązane tematy: </span>
                                    {topic.extra_topics.map(topic => (
                                        <li key={topic.url}>
                                            {" "}
                                            <Link to={topic.url}> {topic.name}</Link>{" "}
                                        </li>
                                    ))}
                                </TagsWrapper>
                            }
                            {topic.last_favourites?.length > 0 &&
                                <Wrapper className="row">
                                    <div className="col-xs-12"> <Heading title="Polecamy" /></div>
                                    {topic.last_favourites.map(post => {
                                        return <div className="col-xs-12 col-sm-6 col-md-3">
                                            {UIStore.isDesktop
                                                ? <PhotoOnTop showDate={true} article={post} />
                                                : <PhotoOnLeft showDate={true} article={post} />}
                                        </div>
                                    })}
                                </Wrapper>}
                        </div>
                        {/* <Adslot name={adPrefix + "_floater"} lazy={false} /> */}
                    </div>
                </Fragment>
                <Footer />
            </>
        )
    }
};

export default withRouter(TopicPage);

const Wrapper = styled("div", {
    marginTop: "24px",
    "@bp4": {
        marginTop: "0px",
    }
});